export default {
  media: {
    source: [],
    autoplay: false
  },
  debug: false,
  autoplay: false,
  controls: {
    native: true,
    mode: 'auto'
  },
  branding: {
    id: 'logo',
    logo: null
  },
  playoverlay: {
    enabled: true
  },
  captioning: {
    enabled: true
  },
  webmd: {
    chapterData: []
  },
  mode: 'html'
};



/** WEBPACK FOOTER **
 ** ./modules/video/configDefaults.js
 **/